"use client";

import React from "react";
import { useAuthUrl } from "../../lib/hooks/useAuthurl";
import Button from "./Button";

export default function FederatedSignInButton({
  buttonText,
  ...buttonProps
}: {
  buttonText?: string;
}) {
  const federatedSignInUrl = useAuthUrl("/federate-sign-in");

  if (!federatedSignInUrl) {
    return null;
  }

  return (
    <Button href={federatedSignInUrl} {...buttonProps}>
      {buttonText || "Federate Sign In"}
    </Button>
  );
}
